import type { User } from '@dashboard/types/user'

export type ManagedAgencyUserLike = Pick<User, 'managed_by_agency' | 'agency_owner_id'> | null | undefined

export function isManagedByAgency(user: ManagedAgencyUserLike): boolean {
  if (!user) {
    return false
  }

  return Boolean(user.managed_by_agency || user.agency_owner_id)
}
